import React from 'react';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { FormattedNumberField } from '@atlassian/jira-platform-utils-number/src/ui/formatted-number-field/index.tsx';
import type {
	BaseField,
	FieldWidth,
	FieldProps,
} from '@atlassian/jira-issue-create-common-types/src/common/types/index.tsx';
import type { FormatConfigurationType } from '@atlassian/jira-platform-utils-number/src/ui/number-field-configuration/types.tsx';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { InputField } from '../../common/ui/fields/base-fields/input-field/index.tsx';
import type {
	Props,
	FieldValue,
	InputFieldConfig,
} from '../../common/ui/fields/base-fields/input-field/types.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import { validateString } from '../../common/utils/validators/index.tsx';
import { preventMouseScrollForNumericFieldHandler } from '../../common/ui/fields/base-fields/input-field/utils.tsx';
import { transformAsString } from './utils.tsx';

const NumberFieldWithoutFormatting = (props: Props) => {
	const { width = 350, ...rest } = props;

	return <InputField type="number" width={width} {...rest} />;
};

const NumberFieldWithFormatting = (props: Props) => {
	if (props.formatConfig) {
		const { width = 350, fieldProps, formatConfig, error, isReadOnly, autoFocus } = props;

		return (
			<FormattedNumberField
				width={width}
				{...fieldProps}
				formatConfig={formatConfig}
				step="any"
				isInvalid={Boolean(error)}
				autoFocus={autoFocus}
				onWheel={preventMouseScrollForNumericFieldHandler}
				isDisabled={isReadOnly || fieldProps.isDisabled}
			/>
		);
	}

	const { width = 350, ...rest } = props;
	return <InputField type="number" width={width} {...rest} />;
};

const NumberField: React.FC<
	BaseField & {
		width?: FieldWidth;
		autoFocus?: boolean;
		onFocus?: () => void;
		onBlur?: () => void;
	} & {
		type?: string;
		defaultValue?: string;
		autoFocus?: boolean;
		onChange?: (value: FieldValue) => void;
		isReadOnly?: boolean;
		formatConfig?: FormatConfigurationType;
	} & {
		defaultValue?: string | undefined;
		error?: string | boolean;
		fieldProps: FieldProps<string>;
		ariaLabelledBy?: string;
		projectKey?: ProjectKey;
	}
> = componentWithFG(
	'frontier-currency-field-d2',
	NumberFieldWithFormatting,
	NumberFieldWithoutFormatting,
);

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { transformAsNumber, mutateNumberField } from './utils';

export default withFormField({
	validator: validateString,
	transformDefaultValue: transformAsString,
})<InputFieldConfig, FieldValue>(
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
	NumberField,
);

export { NumberField };
